mutation StopEntrypointPull($id: ID!) {
  stopEntrypointPull(id: $id) {
    id
    pull {
      sourceUrl
      status
      attempt
      maxAttempts
      startedAt
      finishedAt
      lastError {
        code
        message
      }
    }
  }
}
